module.exports = "/dist/cb72c1f90f66c124fb897a75bec64c78.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900italic.woff2
// module id = 143
// module chunks = 0